import { render, staticRenderFns } from "./KifuControll.vue?vue&type=template&id=2d116088&scoped=true&"
import script from "./KifuControll.vue?vue&type=script&lang=js&"
export * from "./KifuControll.vue?vue&type=script&lang=js&"
import style0 from "./KifuControll.vue?vue&type=style&index=0&id=2d116088&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d116088",
  null
  
)

export default component.exports